import { CompanyFormData } from "../pages/Configurations/tabs/types";
import api from "./api";

export const getHistoryByEntityId = async (
  entityId: string,
  entity: string
) => {
  try {
    const response = await api.get(`/api/history/${entityId}?entity=${entity}`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getStatistics = async () => {
  try {
    const response = await api.get(`/api/history/statistics`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getUserStatistics = async (filter?: any) => {
  try {
    const response = await api.get(`/api/history/userStatistics`, {
      params: filter,
    });
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const approveHistory = async (id: string) => {
  try {
    const response = await api.put(`/api/history/approve/${id}`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const rejectHistory = async (id: string) => {
  try {
    const response = await api.put(`/api/history/reject/${id}`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};
